var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeather = function SvgFeather(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m30.24 16.905.427-.427.848.847-.428.428-3.84 3.847h13.575a10.37 10.37 0 0 0-1.867-12.143l-.413-.412A10.37 10.37 0 0 0 31.199 6a10.37 10.37 0 0 0-7.342 3.045L10.8 22.095v14.258zM26.047 22.8l-6 6h14.257l4.658-4.657q.628-.632 1.132-1.343zM34.8 30l-8.4 8.4H10.447l-4.358 4.358-.427.427-.848-.847.428-.428 4.357-4.357V21.6L23.002 8.198a11.59 11.59 0 0 1 16.395 0l.413.412a11.586 11.586 0 0 1-.008 16.388zm-1.695 0H18.847l-7.2 7.2h14.257z"
  })));
};
export default SvgFeather;